import type { ReactNode } from 'react';
import { HomepageFooter } from '../sections/homepage/HomepageFooter';
import { MarketingSurface } from './MarketingSurface';
import { SiteHeader } from './SiteHeader';
import styles from './interior.module.css';

/** Opt-in composition. The homepage and Reputation compose the same bar themselves. */
export function InteriorPage({ children }: { children: ReactNode }): React.ReactElement {
  return (
    <MarketingSurface>
      <SiteHeader />
      <main id="main-content" className={styles.main}>
        {children}
      </main>
      <HomepageFooter />
    </MarketingSurface>
  );
}
